module.exports = __webpack_public_path__ + "static/media/intro.43a1de2f.mp3";